import { CustomEvents } from './CustomEvents';
import { emit, on } from './EventsBus';

export default class PopupComponent {
  constructor({
    selectors: {
      closeButton = '[data-close-popup]',
      backdrop = '[data-js-backdrop-popup]',
    } = {},
    eventGroup,
    component,
  }) {
    this.eventGroup = eventGroup;
    this.component = component;
    this.closeButton = component.querySelector(closeButton);
    this.backdrop = component.querySelector(backdrop);
    this.emitHide = this.emitHide.bind(this);

    this.bindEvents();
  }

  emitHide(elem) {
    emit(CustomEvents[this.eventGroup].hide,elem);
  }

  bindEvents() {
    // actions
    on(CustomEvents[this.eventGroup].show, () => {
      document.body.style.overflow = 'hidden';
      this.component.classList.add('show');
      this.backdrop.addEventListener('click', this.emitHide);
      this.closeButton.addEventListener('click', this.emitHide);
      emit(CustomEvents[this.eventGroup].shown);
    });
    on(CustomEvents[this.eventGroup].hide, () => {
      document.body.style.overflow = '';
      this.component.classList.remove('show');
      emit(CustomEvents[this.eventGroup].hidden);
    });
  }
}
